module.exports = __webpack_public_path__ + "static/media/intro.7674d422.mp3";